import { defineMessages } from 'react-intl'

const scope =
  'procurify.platform.banking.features.create-beneficiary.presenters.CreateBeneficiaryPresenter'

export default defineMessages({
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  submissionErrorTitle: {
    id: `${scope}.submissionErrorTitle`,
    defaultMessage: 'Submission error',
  },
  submissionErrorMessage: {
    id: `${scope}.submissionErrorMessage`,
    defaultMessage: 'Please address the validation errors in the form',
  },
  submissionError: {
    id: `${scope}.submissionError`,
    defaultMessage: 'An error occurred while submitting the form',
  },
})
